<div class="ui-g searchresultDetail">
    <div class="searchresultListSideLeft">
        <div class="circle-icon">
            <div>
                <img hisImage="job" class="inlineicon" title="{{'rm.erp.jobadvertisement.page.title' | hisUi}}">
            </div>
        </div>
    </div>

    <div class="searchresultListpageCenter">
        <div class="vcardSearchresult">
            <h1>{{'rm.erp.jobadvertisement.page.title' | hisUi}}</h1>
        </div>
        <p-accordion>
            <p-accordionTab *ngFor="let category of categories; let first = first"
                header="{{category.longText}} ({{ category.jobAdvertisements.length }})" [selected]="first">
                <ul class="searchResultList">
                    <li *ngFor="let job of category.jobAdvertisements" class="resultListDetail">
                        <div>
                            <a class="searchResultListTitle" routerLink="/jobadvertisement/view/{{job.id}}">
                                {{job.shortDescription}}
                            </a>
                        </div>
                        <div *ngIf="isRefNumberVisible || isValidToVisible" class="searchResultListDetail">
                            <span *ngIf="job.refNumber && isRefNumberVisible">
                                {{'rm.erp.jobadvertisement.refnumber' | hisUi}}:&nbsp;{{job.refNumber}}
                            </span>
                            <span *ngIf="job.refNumber && isRefNumberVisible && job.validTo && isValidToVisible"> | </span>
                            <span *ngIf="job.validTo && isValidToVisible">
                                {{'rm.erp.jobadvertisement.validto' | hisUi}}:&nbsp;{{job.validTo | hisDate }}
                            </span>
                        </div>
                    </li>
                    <p>&nbsp;</p>
                </ul>
            </p-accordionTab>
        </p-accordion>
    </div>

    <div class="searchresultListpageRight">
        <!--Platzhalter für leere rechte Spalte-->
    </div>
</div>
